import React from 'react';

export default function Services() {
  return (
    <section className="py-20 bg-[#0c0f2c] text-white">
      <div className="container mx-auto px-4 max-w-6xl space-y-20">
        <h2
          className="text-center text-yellow-300 font-bold mb-12"
          style={{ fontSize: '44px', marginBottom: '60px' }}
        >
          Our Services
        </h2>

        {/* Service Block 1 */}
        <div
          className="bg-[#121736] p-8 rounded-2xl shadow-xl hover:shadow-purple-500/20 transition-all duration-300"
          style={{ marginBottom: '50px' }}
        >
          <h3 className="text-yellow-300 mb-1" style={{ fontSize: '36px' }}>
            1. Pipplus Core
          </h3>
          <p className="text-gray-300 mb-1" style={{ fontSize: '18px' }}>
            A fully automated trading service tailored for high-value assets like gold (XAUUSD) and silver (XAGUSD).
          </p>
          <ul className="list-disc pl-5 text-gray-400 space-y-2 mb-1" style={{ fontSize: '16px' }}>
            <li>🟡 <strong>Targeted Commodity Focus:</strong> Gold & Silver optimized strategies</li>
            <li>⚙️ <strong>Fully Automated Execution:</strong> 24/5 instant trading</li>
            <li>📊 <strong>Advanced Market Analysis:</strong> AI & real-time data</li>
            <li>✅ <strong>High Accuracy Signals:</strong> 75–80% with risk control</li>
            <li>🔁 <strong>14–15 Signals Monthly:</strong> Strategically timed alerts</li>
          </ul>
          <p className="text-gray-300" style={{ fontSize: '18px' }}>
            <strong>Risk-Managed Trading:</strong> Adaptive to market with 1:2 risk-reward.
          </p>
        </div>

        {/* Service Block 2 */}
        <div className="bg-[#121736] p-8 rounded-2xl shadow-xl hover:shadow-purple-500/20 transition-all duration-300"
        style={{ marginBottom: '50px' }}>
          <h3 className="text-yellow-300 mb-1" style={{ fontSize: '36px' }}>
            2. Pipplus Pro
          </h3>
          <p className="text-gray-300 mb-1"style={{ fontSize: '18px' }}>
            AI-crafted signals for traders seeking clarity, accuracy, and actionable insights.
          </p>
          <ul className="list-disc pl-5 text-gray-400 space-y-2 mb-1"style={{ fontSize: '16px' }}>
            <li>⚡ <strong>Real-Time Signal Delivery</strong></li>
            <li>🔍 <strong>85–90% Accuracy Rate</strong></li>
            <li>📈 <strong>2–3 Premium Signals Daily</strong></li>
            <li>🔒 <strong>Built-In Risk Management</strong></li>
            <li>📲 <strong>Multi-Device Access</strong></li>
          </ul>
          <p className="text-gray-300" style={{ fontSize: '18px' }}>
            <strong>Ideal For:</strong> Beginners, busy professionals & pros wanting AI confirmation.
          </p>
        </div>

        {/* Service Block 3 */}
        <div className="bg-[#121736] p-8 rounded-2xl shadow-xl hover:shadow-purple-500/20 transition-all duration-300"
        style={{ marginBottom: '50px' }}>
          <h3 className="text-yellow-300 mb-1"style={{ fontSize: '36px' }}>
            3. Pipplus Prime
          </h3>
          <p className="text-gray-300 mb-1"style={{ fontSize: '18px' }}>
            Built for traders who value execution quality. Get lightning-fast, reliable routing every single time.
          </p>
          <ul className="list-disc pl-5 text-gray-400 space-y-2" style={{ fontSize: '16px' }}>
            <li>🔁 <strong>Smart Trade Routing:</strong> Best bid/ask from top LPs</li>
            <li>⚡ <strong>Ultra-Low Latency:</strong> Tier-1 VPS infrastructure</li>
            <li>🛡️ <strong>Reduced Slippage:</strong> Clean execution even in volatile markets</li>
            <li>📶 <strong>Real-Time Connectivity:</strong> MT4/MT5 bridge with 24/7 monitoring</li>
            <li>🔍 <strong>Execution Analytics:</strong> Transparent trade fill breakdowns</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
